module.exports = __webpack_public_path__ + "img/10.c8088c90.png";